import { ActionTrackData } from '../../offers-tracking/client/action-tracking';

export const FT5_OFFERS_ACTION_TRACKING = 'ft5.offers-tracking.action';
export const FT5_OFFERS_ARTICLE_OPTION_CHANGE = 'ft5.offersArticleOption.changeSelectedService';

/**
 *
 *
 */
export function trackClickAction(variationId: string): void {
    const sendData: ActionTrackData = {
        actionName: 'click',
        variationId,
    };
    o_global.eventQBus.emit(FT5_OFFERS_ACTION_TRACKING, sendData);
}
